import React, { useEffect, useState } from 'react'
import Logo from '../../assest/images/37a39cb7092d94d7297953ad09f2dee5.png'
import { FaCircleDot } from "react-icons/fa6";
import '../../CSS/table.css'
import toast, { Toaster } from 'react-hot-toast';
import Swal from 'sweetalert2';

const LiveOpn = () => {
    const [schedules, setSchedules] = useState([]);
    const [opnNumber, setOpnNumber] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const fetchSchedules = async (doctorId) => {
        try {
            const response = await fetch('https://backend.amarasinghemedicare.com/schedule/schedules-with-appointments');
            const data = await response.json();

            if (response.ok) {
                setSchedules(data);
            } else {
                console.error(data.message);
            }
        } catch (error) {
            console.error('Error fetching schedules:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleOpnChange = (e) => {
        setOpnNumber(Number(e.target.value));
    };

    const handleOpnNumberChange = async (id, doctor) => {
        if (opnNumber < 0) {
            toast.error('Ongoing number cannot be negative');
            return;
        }

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to update " + doctor + "'s opn number to " + opnNumber + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, update it!',
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`https://backend.amarasinghemedicare.com/schedule/update-opn/${id}`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ opn: opnNumber }),
                });

                if (response.ok) {
                    toast.success('OPN updated successfully');
                    fetchSchedules();
                } else {
                    const errorData = await response.json();
                    toast.error(errorData.message || 'Failed to update ongoing number');
                }
            } catch (error) {
                console.error('Error updating ongoing number:', error);
                toast.error('Error updating ongoing number');
            }
        }
    };

    const handleOpnNumberClear = async (id, doctor) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "Do you need to clear " + doctor + "'s opn numbers?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, clear it!',
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`https://backend.amarasinghemedicare.com/schedule/update-opn/${id}`, {
                    method: 'PATCH',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ opn: 0 }),
                });

                if (response.ok) {
                    toast.success('OPN updated successfully');
                    fetchSchedules();
                } else {
                    const errorData = await response.json();
                    toast.error(errorData.message || 'Failed to update ongoing number');
                }
            } catch (error) {
                console.error('Error updating ongoing number:', error);
                toast.error('Error updating ongoing number');
            }
        }
    };

    useEffect(() => {
        fetchSchedules();
    }, []);

    return (
        <div>
            <Toaster />
            <div className='bg-white my-2 sm:my-5 md:my-0 w-full sm:w-full md:w-[100%] rounded-lg shadow-md pb-7'>
                <h1 className='p-2 text-xl font-extralight flex justify-start gap-2 items-center'>Today's <span className='text-red font-medium'>Live</span> Appointments <FaCircleDot className='text-red' /></h1>

                <div className='bg-red p-2 rounded-lg shadow-md flex justify-between items-center mx-4'>
                    <h1 className='text-xs font-semibold text-white p-2'>Note: Make sure to clear the OPN number after you have finished seeing the patient of the doctor in question.</h1>
                </div>

                {isLoading ? (
                    <p>Loading schedules...</p>
                ) : Array.isArray(schedules) && schedules.length > 0 ? (
                    schedules.map((schedule) => {
                        const dataObj = new Date(schedule.date);
                        const options = { year: 'numeric', month: 'long', day: 'numeric' };
                        const formattedDate = dataObj.toLocaleDateString(undefined, options);
                        const weekday = dataObj.toLocaleDateString(undefined, { weekday: 'long' });
                        return (
                            <>
                                <div key={schedule.scheduleId} className="mt-7 px-7 ">
                                    <h1 className='bg-blue w-fit p-1 rounded-lg text-white'>{schedule.doctor.fullName} - {weekday}, {formattedDate}</h1>
                                    <div className="flex items-center justify-between mt-2 rounded-lg shadow-lg p-2 bg-white border-l-8 border-green">
                                        <img src={Logo} alt="" className="w-[7%] pl-2 shadow-md p-2 rounded-lg" />


                                        <div className="ml-2">
                                            <h1 className="text-xs font-semibold">Amarasingha Medicare</h1>
                                            <h1 className="text-xs font-extralight">Colombo</h1>
                                            <h1></h1>
                                        </div>

                                        <div className="flex sm:flex-row md:flex-row flex-col gap-4 sm:gap-0 md:gap-0 w-[80%] items-center justify-around">
                                            <div className="flex flex-col items-center justify-center">
                                                <h1 className="text-xs font-semibold text-blue">{schedule.start_time}</h1>
                                                <h1 className="text-xs font-extralight">Starting time</h1>
                                            </div>

                                            <div className="flex flex-col items-center justify-center">
                                                <h1 className="text-xs font-semibold text-red">{schedule.end_time}</h1>
                                                <h1 className="text-xs font-extralight">Ending time</h1>
                                            </div>

                                            <div className="flex flex-col items-center justify-center">
                                                <h1 className="text-xs font-semibold text-red">{schedule.opn}</h1>
                                                <h1 className="text-xs font-extralight">Ongoing Number</h1>
                                            </div>

                                            <div className='flex gap-2 items-center justify-center'>
                                                <input
                                                    type="number"
                                                    value={opnNumber}
                                                    onChange={handleOpnChange}
                                                    className='bg-[#cacaca] rounded-md w-14 pl-3 p-1 font-semibold text-red h-fit'
                                                />

                                                <div className='flex flex-col gap-2'>
                                                    <button
                                                        type='button'
                                                        onClick={() => handleOpnNumberChange(schedule.scheduleId, schedule.doctor.fullName)}
                                                        className="text-xs text-white uppercase text-left bg-[#97CE4F] py-2 px-10 rounded-lg transform transition-transform duration-300 hover:scale-105"
                                                    >
                                                        Update
                                                    </button>

                                                    <button
                                                        type='button'
                                                        onClick={() => handleOpnNumberClear(schedule.scheduleId, schedule.doctor.fullName)}
                                                        className="text-xs text-white uppercase text-left bg-red py-2 px-10 rounded-lg transform transition-transform duration-300 hover:scale-105"
                                                    >
                                                        Clear
                                                    </button>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        );
                    })
                ) : (
                    <p className='p-10'>No schedules available today.</p>
                )}
            </div>
        </div>
    )
}

export default LiveOpn